import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes as Auth } from '@/layouts/auth'
import { routes as dashboard } from '@/layouts/dashboard'
import beforeEach from './beforeEach'

Vue.use(VueRouter)

const PageNotFound = [{ path: '*', redirect: '/home' }]

const routes = [...PageNotFound, ...Auth, ...dashboard]

const router = new VueRouter({
  routes,
})

router.beforeEach(beforeEach)

export default router
